import { FC, SVGAttributes } from 'react';

const KYC: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0857 1.94286C16.0857 1.42213 16.5078 1 17.0286 1C20.3265 1 23 3.6735 23 6.97143C23 7.49215 22.5779 7.91429 22.0571 7.91429C21.5364 7.91429 21.1143 7.49215 21.1143 6.97143C21.1143 4.71495 19.285 2.88571 17.0286 2.88571C16.5078 2.88571 16.0857 2.46358 16.0857 1.94286Z"
                fill="currentColor"
            />
            <path
                d="M12 5.4C10.2642 5.4 8.85714 6.80711 8.85714 8.54286C8.85714 10.2786 10.2642 11.6857 12 11.6857C13.7358 11.6857 15.1429 10.2786 15.1429 8.54286C15.1429 6.80711 13.7358 5.4 12 5.4Z"
                fill="currentColor"
            />
            <path
                d="M9.88128 12.6405C8.38598 12.8791 7.28571 14.1689 7.28571 15.6831V15.9158C7.28571 17.0511 8.20606 17.9714 9.34135 17.9714H14.6586C15.7939 17.9714 16.7143 17.0511 16.7143 15.9158V15.6831C16.7143 14.1689 15.614 12.8791 14.1187 12.6405C12.7151 12.4165 11.2849 12.4165 9.88128 12.6405Z"
                fill="currentColor"
            />
            <path
                d="M2.88571 17.0286C2.88571 16.5078 2.46358 16.0857 1.94286 16.0857C1.42213 16.0857 1 16.5078 1 17.0286C1 20.3265 3.6735 23 6.97143 23C7.49215 23 7.91429 22.5779 7.91429 22.0571C7.91429 21.5364 7.49215 21.1143 6.97143 21.1143C4.71495 21.1143 2.88571 19.285 2.88571 17.0286Z"
                fill="currentColor"
            />
            <path
                d="M1 6.97143C1 3.6735 3.6735 1 6.97143 1C7.49215 1 7.91429 1.42213 7.91429 1.94286C7.91429 2.46358 7.49215 2.88571 6.97143 2.88571C4.71495 2.88571 2.88571 4.71495 2.88571 6.97143C2.88571 7.49215 2.46358 7.91429 1.94286 7.91429C1.42213 7.91429 1 7.49215 1 6.97143Z"
                fill="currentColor"
            />
            <path
                d="M23 17.0286C23 16.5078 22.5779 16.0857 22.0571 16.0857C21.5364 16.0857 21.1143 16.5078 21.1143 17.0286C21.1143 19.285 19.285 21.1143 17.0286 21.1143C16.5078 21.1143 16.0857 21.5364 16.0857 22.0571C16.0857 22.5779 16.5078 23 17.0286 23C20.3265 23 23 20.3265 23 17.0286Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default KYC;
